<div class="form-summary">
  <label class="col-5 col-md-6"><ng-content></ng-content></label>
    <span class="form-summary-item col-6 ps-4">{{phoneDisplay}}</span>
</div>
